import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useCallback } from 'react';
import { Scope } from '@sentry/browser';
// eslint-disable-next-line import/order
import { Breadcrumb, breadcrumbMountedEventChannel, externalGasV3OperationalEventChannel, externalGasV3ScreenEventChannel, externalGasV3TrackEventChannel, externalGasV3UIEventChannel, externalSentryExceptionChannel, internalGasV3OperationalEventChannel, internalGasV3ScreenEventChannel, internalGasV3TrackEventChannel, internalGasV3UIEventChannel, internalSentryExceptionChannel } from './common/utils/channels';

// eslint-disable-next-line import/order
import { createAnalyticsClient, createSentryClient } from './common/utils/clients';

// eslint-disable-next-line import/order
import { breadcrumbMountedPayloadToGasV3ScreenEvent, getTelemetryGasV3SharedInfo, nestListeners, withSentryExceptionTelemetryInformation } from './common/utils/events';
export { createAnalyticsClient };
export { Breadcrumb };

// eslint-disable-next-line import/order
import * as ProbabilityOfBug from './common/utils/probability-of-bug';
export { ProbabilityOfBug };
export { useTaskTracker } from './common/utils/task-tracker';
export { isSuccessfulTaskResult } from './common/utils/task-tracker';
// eslint-disable-next-line import/order
import * as Service from './common/utils/service';
export { Service };
var lazyContructor = function lazyContructor(factory) {
  var fabricated;
  return function () {
    if (!fabricated) {
      fabricated = factory();
    }
    return fabricated;
  };
};

// Construct clients lazily to avoid using DOM APIs on import
var getAnalyticsClient = lazyContructor(createAnalyticsClient);
var getSentryClient = lazyContructor(createSentryClient);
var SinglePackageSafeGuard = function SinglePackageSafeGuard(_ref) {
  var children = _ref.children,
    childPackageListenerModule = _ref.childPackageListenerModule;
  var gasV3UIEventDispatch = externalGasV3UIEventChannel.useEventDispatch();
  var gasV3ScreenEventDispatch = externalGasV3ScreenEventChannel.useEventDispatch();
  var gasV3TrackEventDispatch = externalGasV3TrackEventChannel.useEventDispatch();
  var gasV3OperationalEventDispatch = externalGasV3OperationalEventChannel.useEventDispatch();
  var sentryExceptionDispatch = externalSentryExceptionChannel.useEventDispatch();
  return nestListeners(children, [
  // Don't bother redispatching if it's the current package and child package listeners are the same component
  childPackageListenerModule.GasV3UIEventListener !== externalGasV3UIEventChannel.Listener ? {
    Listener: childPackageListenerModule.GasV3UIEventListener,
    onEvent: gasV3UIEventDispatch
  } : null, childPackageListenerModule.GasV3ScreenEventListener !== externalGasV3ScreenEventChannel.Listener ? {
    Listener: childPackageListenerModule.GasV3ScreenEventListener,
    onEvent: gasV3ScreenEventDispatch
  } : null, childPackageListenerModule.GasV3TrackEventListener !== externalGasV3TrackEventChannel.Listener ? {
    Listener: childPackageListenerModule.GasV3TrackEventListener,
    onEvent: gasV3TrackEventDispatch
  } : null, childPackageListenerModule.GasV3OperationalEventListener !== externalGasV3UIEventChannel.Listener ? {
    Listener: childPackageListenerModule.GasV3OperationalEventListener,
    onEvent: gasV3OperationalEventDispatch
  } : null, childPackageListenerModule.SentryExceptionListener !== externalSentryExceptionChannel.Listener ? {
    Listener: childPackageListenerModule.SentryExceptionListener,
    onEvent: sentryExceptionDispatch
  } : null].filter(function (input) {
    return input !== null;
  }));
};
export var ChannelVersionFragmentationSafeGuard = function ChannelVersionFragmentationSafeGuard(_ref2) {
  var childPackageListenerModules = _ref2.childPackageListenerModules,
    children = _ref2.children;
  var wrappedChildren = /*#__PURE__*/React.createElement(React.Fragment, null, children);
  var _iterator = _createForOfIteratorHelper(childPackageListenerModules),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var module = _step.value;
      wrappedChildren = SinglePackageSafeGuard({
        children: wrappedChildren,
        childPackageListenerModule: module
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return wrappedChildren;
};
var getNonDevBreadcrumbs = function getNonDevBreadcrumbs(breadcrumbs) {
  return breadcrumbs.filter(function (breadcrumb) {
    return !breadcrumb.isForDevsOnly;
  });
};
var withCommercePackagesGasV3SharedInfo = function withCommercePackagesGasV3SharedInfo(breadcrumbedPayload) {
  var sharedInfo = getTelemetryGasV3SharedInfo({
    breadcrumbs: getNonDevBreadcrumbs(breadcrumbedPayload.breadcrumbs)
  });
  return _objectSpread(_objectSpread(_objectSpread({}, sharedInfo), breadcrumbedPayload.payload), {}, {
    attributes: _objectSpread(_objectSpread({}, breadcrumbedPayload.payload.attributes), sharedInfo.attributes)
  });
};
var BreadcrumbMountedToScreenTransformer = function BreadcrumbMountedToScreenTransformer(_ref3) {
  var children = _ref3.children;
  var internalGasV3ScreenEventDispatch = internalGasV3ScreenEventChannel.useEventDispatch();
  return /*#__PURE__*/React.createElement(breadcrumbMountedEventChannel.Listener, {
    onEvent: useCallback(function (breadcrumbPayload) {
      if (!breadcrumbPayload.payload.isForDevsOnly) {
        var gasV3ScreenPayload = breadcrumbMountedPayloadToGasV3ScreenEvent(breadcrumbPayload);
        internalGasV3ScreenEventDispatch(gasV3ScreenPayload);
      }
    }, [internalGasV3ScreenEventDispatch])
  }, children);
};
export var InternalCommerceTelemetryIntegrations = function InternalCommerceTelemetryIntegrations(_ref4) {
  var children = _ref4.children;
  var gasV3UIEventDispatch = externalGasV3UIEventChannel.useEventDispatch();
  var gasV3ScreenEventDispatch = externalGasV3ScreenEventChannel.useEventDispatch();
  var gasV3TrackEventDispatch = externalGasV3TrackEventChannel.useEventDispatch();
  var gasV3OperationalEventDispatch = externalGasV3OperationalEventChannel.useEventDispatch();
  var sentryExceptionDispatch = externalSentryExceptionChannel.useEventDispatch();
  var childrenWrappedInScreenTransformer = /*#__PURE__*/React.createElement(BreadcrumbMountedToScreenTransformer, null, children);
  return nestListeners(childrenWrappedInScreenTransformer, [{
    Listener: internalGasV3UIEventChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var gasV3Payload = withCommercePackagesGasV3SharedInfo(breadcrumbedPayload);
      getAnalyticsClient().sendUIEvent(gasV3Payload);
      gasV3UIEventDispatch(gasV3Payload);
    }, [gasV3UIEventDispatch])
  }, {
    Listener: internalGasV3ScreenEventChannel.Listener,
    onEvent: useCallback(function (payload) {
      getAnalyticsClient().sendScreenEvent(payload);
      gasV3ScreenEventDispatch(payload);
    }, [gasV3ScreenEventDispatch])
  }, {
    Listener: internalGasV3TrackEventChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var gasV3Payload = withCommercePackagesGasV3SharedInfo(breadcrumbedPayload);
      getAnalyticsClient().sendTrackEvent(gasV3Payload);
      gasV3TrackEventDispatch(gasV3Payload);
    }, [gasV3TrackEventDispatch])
  }, {
    Listener: internalGasV3OperationalEventChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var gasV3Payload = withCommercePackagesGasV3SharedInfo(breadcrumbedPayload);
      getAnalyticsClient().sendOperationalEvent(gasV3Payload);
      gasV3OperationalEventDispatch(gasV3Payload);
    }, [gasV3OperationalEventDispatch])
  }, {
    Listener: internalSentryExceptionChannel.Listener,
    onEvent: useCallback(function (breadcrumbedPayload) {
      var _scopeContext$tags, _scopeContext$level;
      var payload = withSentryExceptionTelemetryInformation(breadcrumbedPayload);
      var exception = payload.exception,
        hint = payload.hint,
        scopeContext = payload.scopeContext;
      var scope = new Scope();

      // TODO: There are alternative ways of doing this. E.g. Using eventFromException. Once decided, we should move it to the Sentry transformers package
      scope.setTags((_scopeContext$tags = scopeContext.tags) !== null && _scopeContext$tags !== void 0 ? _scopeContext$tags : {});
      for (var _i = 0, _Object$entries = Object.entries((_scopeContext$context = scopeContext.contexts) !== null && _scopeContext$context !== void 0 ? _scopeContext$context : {}); _i < _Object$entries.length; _i++) {
        var _scopeContext$context;
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          context = _Object$entries$_i[1];
        scope.setContext(key, context || null);
      }
      if (scopeContext.fingerprint !== undefined) {
        scope.setFingerprint(scopeContext.fingerprint);
      }
      scope.setLevel((_scopeContext$level = scopeContext.level) !== null && _scopeContext$level !== void 0 ? _scopeContext$level : 'fatal');
      getSentryClient().captureException(exception, hint, scope);
      sentryExceptionDispatch(payload);
    }, [sentryExceptionDispatch])
  }]);
};